import React from 'react'
import {formatPrice} from '../../../../../Common/Formatter'
import {PAYMENT} from '../../../../../Common/Constants'
import {ContractInfoWithContractDate} from '../../../../Props/ContractInputInfo'
import {ContentBlock} from '../../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../../Molecules/BaseContentBlocks/ContentTitle'
import {ConfirmContent} from '../../../Molecules/BaseContentBlocks/ConfirmContent'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {CvsContract} from '../../../../DTO/CvsContractDTO'
import {Signboard} from '../../../../DTO/SignboardDTO'
import {MBContentNoteWithMarkTypography, MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {convenienceStoreKeyToName} from '../InputContentBlocks/ConvenienceStoreInputComponent'
import {Color} from '../../../Styles'
import {LinkIconText} from '../../../Molecules/LinkIconText'
import {Spacer} from '../../../../../Common/Components/Spacer'

interface CvsPaymentInfoContentBlockProps {
  title: string
  contractInfoWithContractDate: ContractInfoWithContractDate
  cvsContract: CvsContract
  signboard: Signboard
  dataTestId?: string
}

export const CvsPaymentInfoContentBlock: React.VFC<CvsPaymentInfoContentBlockProps> = (
  props
) => {
  const {term, amount, contractDate} = props.contractInfoWithContractDate
  const {
    convenienceStoreKey,
    paymentNumberLabel,
    paymentNumber,
    confirmationNumber,
    confirmationNumberLabel,
    paymentTerm,
    paymentDetailUrl
  } = props.cvsContract
  const {signupName} = props.signboard

  const cvsName = convenienceStoreKeyToName(convenienceStoreKey)

  return (
    <ContentBlock data-testid={props.dataTestId}>
      <PIMStack spacing={'18px'}>
        <ContentTitle noMarginBottom={true}>{props.title}</ContentTitle>
        <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showEndDivider>
          <PIMStack spacing={'10px'}>
            <MBContentSubTitleTypography>
              {signupName}への入会手続きありがとうございます！
            </MBContentSubTitleTypography>
            <MBContentSubTitleTypography>
              お支払いいただく際に下記の情報が必要となりますので、お控えください。
            </MBContentSubTitleTypography>
          </PIMStack>
          <ConfirmContent
            label={'お支払い先コンビニ'}
            values={[cvsName]}
          />
          <ConfirmContent
            label={paymentNumberLabel}
            values={[paymentNumber]}
          />
          <ConfirmContent
            label={confirmationNumberLabel}
            values={[confirmationNumber]}
          />
          <ConfirmContent
            label={'お支払い金額'}
            values={[`${formatPrice(amount)}円(税込)`]}
          />
          <ConfirmContent
            label={'お支払い期限'}
            values={[paymentTerm]}
            valueColor={Color.Red500}
          />
          <PIMStack spacing={'10px'}>
            <ConfirmContent
              label={'契約期間'}
              values={[
                `${PAYMENT.TERMS[term].displayLabel}(更新する場合は手続きが必要です)`,
                `${contractDate.contractDate} 〜 ${contractDate.contractEndDate}`,
              ]}
            />
            <MBContentNoteWithMarkTypography note={'実際の契約期間はコンビニでお支払いいただいた月から11ヶ月後の月末日までとなります。'}/>
          </PIMStack>
          <PIMStack spacing={'10px'}>
            <ConfirmContent
              label={'お支払い方法'}
              values={['下記リンクよりお支払い方法をご確認ください。']}
            />
            <LinkIconText href={paymentDetailUrl}>
              {`${cvsName}でのお支払い方法について`}
            </LinkIconText>
            <Spacer mt={'0'}/>
          </PIMStack>
        </PIMStack>
      </PIMStack>
    </ContentBlock>
  )
}
